<template>
  <div class="main">
    <Header
      :show="true"
      title="预约审核"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-cell :value="listQuery.date.range" is-link @click="listQuery.date.show = true">
        <template #title>
          <span style="font-size: 2vh;">时间区间</span>
        </template>
      </van-cell>
      <van-calendar
        v-model="listQuery.date.show"
        type="range"
        :max-range="366"
        :min-date="listQuery.date.min"
        :max-date="listQuery.date.max"
        :default-date="listQuery.date.default"
        color="#ee0a24"
        :style="{ 'padding-bottom': '30px' }"
        @confirm="onConfirmDateChoose"
      />
      <van-cell :value="listQuery.area.name" is-link @click="listQuery.area.show = true">
        <template #title>
          <span style="font-size: 2vh;">访问区域</span>
        </template>
      </van-cell>
      <van-action-sheet
        v-model="listQuery.area.show"
        :actions="listQuery.area.actions"
        cancel-text="取消"
        description="请选择待查询的访问区域"
        @select="onSelectAreaChoose"
      />
      <van-cell :value="listQuery.status.name" is-link @click="listQuery.status.show = true">
        <template #title>
          <span style="font-size: 2vh;">当前状态</span>
        </template>
      </van-cell>
      <van-action-sheet
        v-model="listQuery.status.show"
        :actions="listQuery.status.actions"
        cancel-text="取消"
        description="请选择待查询的当前状态"
        @select="onSelectStatusChoose"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" @click="handleClickQuery">
          查询
        </van-button>
      </div>

      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
      >
        <el-table-column type="expand" width="30px">
          <template slot-scope="{row}">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item v-if="listQuery.area.name === '原料区道闸' || listQuery.area.name === '办公区道闸'" label="车牌号">
                <span>{{ row.plateNumber }}</span>
              </el-form-item>
              <el-form-item v-else label="人脸照片">
                <!-- <span>{{ faceImage }}</span> -->
                <van-image
                  width="100px"
                  height="100px"
                  :src="row.faceImage"
                  @click="handleClickPreview(row.faceImage)"
                >
                  <template v-slot:index>人脸照片</template>
                </van-image>
              </el-form-item>
              <el-form-item v-if="listQuery.area.name === '原料区道闸'" label="车辆类型">
                <span>{{ row.truckType }}</span>
              </el-form-item>
              <el-form-item v-if="listQuery.area.name === '原料区道闸'" label="物料">
                <span>{{ row.materialName }}</span>
              </el-form-item>
              <el-form-item v-if="listQuery.area.name === '原料区道闸'" label="供应商">
                <span>{{ row.supplierName }}</span>
              </el-form-item>
              <el-form-item v-if="listQuery.area.name === '原料区道闸' || listQuery.area.name === '办公区道闸'" label="司机">
                <span>{{ row.driver }}</span>
              </el-form-item>
              <el-form-item v-else label="姓名">
                <span>{{ row.name }}</span>
              </el-form-item>
              <el-form-item label="手机号码">
                <span>{{ row.phone }}</span>
              </el-form-item>
              <el-form-item label="事由">
                <span>{{ row.reason }}</span>
              </el-form-item>
              <el-form-item label="入场时间">
                <span>{{ row.startDate }}</span>
              </el-form-item>
              <el-form-item label="离场时间">
                <span>{{ row.endDate }}</span>
              </el-form-item>
              <el-form-item label="状态">
                <el-tag v-if="row.status === '待审核'" type="warning">{{ row.status }}</el-tag>
                <el-tag v-else-if="row.status === '已通过'" type="success">{{ row.status }}</el-tag>
                <el-tag v-else-if="row.status === '长期有效'" type="success">{{ row.status }}</el-tag>
                <el-tag v-else-if="row.status === '已拒绝'" type="danger">{{ row.status }}</el-tag>
                <el-tag v-else-if="row.status === '已出场'"  type="primary">{{ row.status }}</el-tag>
                <el-tag v-else type="info">{{ row.status }}</el-tag>
              </el-form-item>
              <el-form-item label="创建人">
                <span>{{ row.createdBy }}</span>
              </el-form-item>
              <el-form-item label="创建时间">
                <span>{{ row.createdTime }}</span>
              </el-form-item>
              <el-form-item label="审核人">
                <span>{{ row.updatedBy }}</span>
              </el-form-item>
              <el-form-item label="审核时间">
                <span>{{ row.updatedTime }}</span>
              </el-form-item>
              <el-form-item label="操作" v-if="((listQuery.area.name !== '原料区') && checkPermission([12])) ||  ((listQuery.area.name === '原料区') && checkPermission([13]))">
                <el-button v-if="row.status === '待审核'" type="primary" size="mini" @click="handleClickUpdateDialog(row)">
                  审核
                </el-button>
                <el-button v-else type="info" size="mini" disabled>
                  审核
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="id" align="center" width="40">
          <template slot-scope="{row}">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="startDate" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ row.startDate }}
          </template>
        </el-table-column>
        <el-table-column :label="(listQuery.area.name === '原料区道闸'  || listQuery.area.name === '办公区道闸') ? '车牌号' : '姓名'" prop="content" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            <span v-if="listQuery.area.name === '原料区道闸'  || listQuery.area.name === '办公区道闸'">{{ row.plateNumber }}</span>
            <span v-else>{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.status === '待审核'" type="warning">{{ row.status }}</el-tag>
            <el-tag v-else-if="row.status === '已通过'" type="success">{{ row.status }}</el-tag>
            <el-tag v-else-if="row.status === '长期有效'" type="success">{{ row.status }}</el-tag>
            <el-tag v-else-if="row.status === '已拒绝'" type="danger">{{ row.status }}</el-tag>
            <el-tag v-else-if="row.status === '已出场'"  type="primary">{{ row.status }}</el-tag>
            <el-tag v-else type="info">{{ row.status }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total>0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth>380?5:3"
        style="margin: .6rem 0; text-align: center;"
        @current-change="handleClickQuery"
      />
      <div style="height: 1rem; background-color: #FFFFFF;" />

      <van-dialog
        v-model="dialogVisibleUpdate"
        title="预约审核"
        show-cancel-button
        :before-close="handleClickUpdateConfirm"
      >
        <van-field
          label="操作"
          required
        >
          <template #input>
            <van-radio-group v-model="listQuery.verify" direction="horizontal">
              <van-radio :name="0">同意</van-radio>
              <van-radio :name="1">拒绝</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="listQuery.verify === 1"
          ref="reason"
          v-model="listQuery.reason"
          rows="1"
          autosize
          label="原因"
          type="textarea"
          maxlength="100"
          placeholder="请输入拒绝原因"
          show-word-limit
          required
        />
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog, ImagePreview } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getManOrderList, updateManOrderOne, getCarOrderList, updateCarOrderOne, getTruckOrderList, updateTruckOrderOne } from '@/api/verify.js'


  export default {
    name: "ServiceBussinessVerify",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      const EDate = parseTime(new Date(), '{y}/{m}/{d}')
      const dayTimeStamp = (new Date(EDate)).getTime()
      const beforeTimeStamp = dayTimeStamp - 7*24*3600*1000
      const SDate = parseTime(beforeTimeStamp, '{y}/{m}/{d}')
      return {
        dialogVisibleUpdate: false,
        baseUrl: '',
        listQuery: {
          limit: 10,
          page: 1,
          date: {
            show: false,
            min: new Date(2020, 1, 1),
            max: new Date(2030, 12, 31),
            range: SDate + ' - ' + EDate,
            start: beforeTimeStamp,
            end: dayTimeStamp,
            default: [new Date(SDate), new Date(EDate)]
          },
          name: '',
          plateNumber: '',
          area: {
            show: false,
            actions: [
              // { name: '办公区', value: 1, subname: '' },
              // { name: '生产区', value: 2 },
              { name: '办公区+生产区人脸', value: 9 },
              { name: '办公区道闸', value: 4 },
              { name: '原料区道闸', value: 3 }
            ],
            name: '原料区道闸',
            value: 3
          },
          status: {
            show: false,
            actions: [
              { name: '全部', value: 9, subname: '' },
              { name: '待审核', value: 0 },
              { name: '已通过', value: 1 },
              { name: '已拒绝', value: 2 }
            ],
            name: '全部',
            value: 9
          },
          id: null,
          verify: 0,
          reason: ''
        },
        isLoading: false,
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.id
        }
      }
    },
    computed: {

    },
    watch: {

    },
    beforeCreate() {

    },
    created() {
      const url = window.location.href
      this.baseUrl = url.substr(0, url.indexOf('/ndwnq')) + '/ndwnq'
      this.handleClickQuery()
    },
    beforeMount() {

    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({
          path:'/service/system/staff/create',
          query: {} ,
        })
      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        if (row.area === '原料区道闸') {
          return 'area-produce'
        } else if (row.area === '办公区') {
          return 'area-office1'
        } else if (row.area === '生产区') {
          return 'area-office2'
        }
        return 'normal-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      formatDate(date) {
        const year = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        return `${year}/${(month + 1) >9 ? (month + 1) : '0'+(month + 1)}/${day > 9 ? day : '0'+day}`
      },
      onConfirmDateChoose(date) {
        const [start, end] = date
        this.listQuery.date.show = false
        this.listQuery.date.range = `${this.formatDate(start)} - ${this.formatDate(end)}`
        this.listQuery.date.start = (new Date(start)).getTime()
        this.listQuery.date.end = (new Date(end)).getTime()
      },
      onSelectAreaChoose(item) {
        this.listQuery.area.show = false
        this.listQuery.area.name = item.name
        this.listQuery.area.value = item.value
        this.handleClickQuery()
      },
      onSelectStatusChoose(item) {
        this.listQuery.status.show = false
        this.listQuery.status.name = item.name
        this.listQuery.status.value = item.value
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
          this.listQuery.page++
          if (this.listQuery.limit * (this.listQuery.page + 1) < this.table.total) {
            this.handleClickQuery()
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, '拉取预约记录', '没有新的数据')
          }
        }, 1000)
      },
      handleClickPreview(url) {
        ImagePreview([url])
      },
      handleClickQuery() {
        if (this.listQuery.area.name === '办公区道闸') {
          const data = {
            page: this.listQuery.page,
            limit: this.listQuery.limit,
            start: this.listQuery.date.start,
            end: this.listQuery.date.end,
            plateNumber: this.listQuery.plateNumber,
            status: this.listQuery.status.value
          }
          getCarOrderList(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
              this.table.total = data.data.total
              const items = data.data.items
              this.table.data = []
              for (let i=0; i<items.length; i++) {
                let status = '待审核'
                if (items[i].audit === 0) {
                  status = '待审核'
                } else if (items[i].audit === 1) {
                  status = '已通过'
                  if (items[i].isFailure === 1) {
                    status = '已出场'
                  } else if (items[i].endDate < (new Date(parseTime(new Date(), '{y}/{m}/{d}'))).getTime()) {
                    status = '已失效'
                  }
                } else if (items[i].audit === 2) {
                  status = '已拒绝'
                }
                this.table.data.push({
                  id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                  serial: items[i].id,
                  plateNumber: items[i].plateNumber,
                  driver: items[i].name,
                  phone: items[i].phone,
                  reason: items[i].reason,
                  startDate: parseTime(items[i].startDate, '{y}-{m}-{d}'),
                  endDate: parseTime(items[i].endDate, '{y}-{m}-{d}'),
                  status: status,
                  createdBy: items[i].createdBy,
                  createdTime: parseTime(items[i].createdTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                  updatedBy: items[i].updatedBy,
                  updatedTime: parseTime(items[i].updatedTime, '{y}-{m}-{d} {h}:{i}:{s}')
                })
              }
            }
          }).catch(function(error) {
            console.error(error)
          })
        } else if (this.listQuery.area.name === '原料区道闸') {
          const data = {
            page: this.listQuery.page,
            limit: this.listQuery.limit,
            start: this.listQuery.date.start,
            end: this.listQuery.date.end,
            plateNumber: this.listQuery.plateNumber,
            status: this.listQuery.status.value
          }
          getTruckOrderList(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
              this.table.total = data.data.total
              const items = data.data.items
              this.table.data = []
              for (let i=0; i<items.length; i++) {
                let status = '待审核'
                if (items[i].audit === 0) {
                  status = '待审核'
                } else if (items[i].audit === 1) {
                  status = '已通过'
                  if (items[i].isFailure === 1) {
                    status = '已出场'
                  } else if (items[i].endDate < (new Date(parseTime(new Date(), '{y}/{m}/{d}'))).getTime()) {
                    status = '已失效'
                  }
                } else if (items[i].audit === 2) {
                  status = '已拒绝'
                }
                this.table.data.push({
                  id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                  serial: items[i].id,
                  plateNumber: items[i].plateNumber,
                  truckType: items[i].truckType,
                  materialName: items[i].materialName,
                  supplierName: items[i].supplierName,
                  driver: items[i].name,
                  phone: items[i].phone,
                  reason: items[i].reason,
                  startDate: parseTime(items[i].startDate, '{y}-{m}-{d}'),
                  endDate: parseTime(items[i].endDate, '{y}-{m}-{d}'),
                  status: status,
                  createdBy: items[i].createdBy,
                  createdTime: parseTime(items[i].createdTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                  updatedBy: items[i].updatedBy,
                  updatedTime: parseTime(items[i].updatedTime, '{y}-{m}-{d} {h}:{i}:{s}')
                })
              }
            }
          }).catch(function(error) {
            console.error(error)
          })
        } else {
          const data = {
            page: this.listQuery.page,
            limit: this.listQuery.limit,
            start: this.listQuery.date.start,
            end: this.listQuery.date.end,
            gate: this.listQuery.area.value,
            status: this.listQuery.status.value,
            name: this.listQuery.name
          }
          getManOrderList(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
              this.table.total = data.data.total
              const items = data.data.items
              this.table.data = []
              for (let i=0; i<items.length; i++) {
                let status = '待审核'
                if (items[i].audit === 0) {
                  status = '待审核'
                } else if (items[i].audit === 1) {
                  status = '已通过'
                  if (items[i].validEnable === 1) {
                    status = '长期有效'
                  } else if (items[i].isFailure === 1) {
                    status = '已出场'
                  } else if (items[i].endDate + 86400000 < (new Date()).getTime()) {
                    status = '已失效'
                  }
                } else if (items[i].audit === 2) {
                  status = '已拒绝'
                }
                let url = this.baseUrl + items[i].faceImage
                this.table.data.push({
                  id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                  serial: items[i].id,
                  faceImage: url,
                  name: items[i].name,
                  phone: items[i].phone,
                  reason: items[i].reason,
                  startDate: parseTime(items[i].startDate, '{y}-{m}-{d}'),
                  endDate: parseTime(items[i].endDate, '{y}-{m}-{d}'),
                  status: status,
                  createdBy: items[i].createdBy,
                  createdTime: parseTime(items[i].createdTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                  updatedBy: items[i].updatedBy,
                  updatedTime: parseTime(items[i].updatedTime, '{y}-{m}-{d} {h}:{i}:{s}')
                })
              }
            }
          }).catch(function(error) {
            console.error(error)
          })
        }
      },
      handleClickUpdateDialog(row) {
        this.listQuery.id = row.serial
        this.dialogVisibleUpdate = true
      },
      handleClickUpdateConfirm(action, done) {
        if (action === 'confirm') {
          if ((this.listQuery.verify === 1) && (this.listQuery.reason === '')) {
            showPhoneAlarm(true, 'toast', null, 2000, 300, null, '请输入拒绝原因')
            done(false)
          } else {
            const data = {
              id: this.listQuery.id,
              yesOrNo: this.listQuery.verify,
              rejectReason: this.listQuery.reason
            }
            this.loading = true
            if (this.listQuery.area.name === '办公区道闸') {
              updateCarOrderOne(data).then(response => {
                const { data } = response
                if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '预约审核', data.message)) {
                  this.handleClickQuery()
                  done(true)
                }
                this.loading = false
              }).catch(function(error) {
                this.loading = false
                console.error(error)
              })
            } else if (this.listQuery.area.name === '原料区道闸') {
              updateTruckOrderOne(data).then(response => {
                const { data } = response
                if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '预约审核', data.message)) {
                  this.handleClickQuery()
                  done(true)
                }
                this.loading = false
              }).catch(function(error) {
                this.loading = false
                console.error(error)
              })
            } else {
              updateManOrderOne(data).then(response => {
                const { data } = response
                if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '预约审核', data.message)) {
                  this.handleClickQuery()
                  done(true)
                }
                this.loading = false
              }).catch(function(error) {
                this.loading = false
                console.error(error)
              })
            }
          }
        } else {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '取消审核')
          done(true)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .el-form-item__label {
    width: 20%;
    text-align: right;
    // margin-right: 20px;
  }
  ::v-deep .el-table__expanded-cell[class*=cell] {
    padding: 20px 10px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  ::v-deep .van-cell__title {
    max-width: 30%;
  }
  ::v-deep .van-cell__value {
    max-width: 70%;
  }
  ::v-deep .el-table th>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-table td>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA;
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
</style>
